import { FC, useRef } from 'react';
import { toast } from 'react-toastify';

import { Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { GridColDef } from '@material-ui/data-grid';
import AddIcon from '@material-ui/icons/Add';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import FilterDrawer from 'src/components/FilterDrawer';
import { FilterDrawerRef } from 'src/components/FilterDrawer/interfaces';
import LinkButton from 'src/components/LinkButton';
import Table from 'src/components/Table';
import TableActions from 'src/components/Table/Actions';
import CustomMenuItem from 'src/components/Table/CustomMenuItem';
import usePagination from 'src/hooks/usePagination';
import IMedia from 'src/interfaces/models/IMedia';
import MediaFilterSchema from 'src/validators/Media/filter.schema';

import Filters from './Filters';
import { Container } from './styles';

const List: FC = () => {
  const filterRef = useRef<FilterDrawerRef>(null);
  const {
    handlePageChange,
    handlePageSizeChange,
    data,
    loading,
    info,
    loadData,
  } = usePagination<IMedia>('admin/medias');

  function copyToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.info('Link Copiado!');
  }

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
      field: 'file',
      headerName: 'Arquivo',
      width: 120,
      renderCell({ row }) {
        return (
          <img
            src={row.file}
            alt={row.name}
            width="100%"
            style={{ objectFit: 'contain' }}
          />
        );
      },
    },
    { field: 'name', headerName: 'Nome', flex: 1 },
    {
      field: '',
      disableColumnMenu: true,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell({ id, row }) {
        return (
          <TableActions
            resource="Mídia"
            editLink={`/midias/${id}`}
            deleteApiUrl={`/admin/medias/${id}`}
            canDelete
            canDeactivate={false}
            descriptionPrefix={`A mídia ${id}`}
            onFinish={loadData}
            startItems={
              <CustomMenuItem
                Icon={FileCopyIcon}
                text="Copiar Link"
                onClick={() => copyToClipboard(row.file)}
              />
            }
          />
        );
      },
    },
  ];

  return (
    <Container>
      <FilterDrawer
        ref={filterRef}
        columns={columns.filter((column) => !column.hide && column.field)}
        yupSchema={MediaFilterSchema}
      >
        <Filters formRef={filterRef.current?.getFormRef()} />
      </FilterDrawer>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h5">Mídias</Typography>

            <LinkButton
              to="/midias/novo"
              startIcon={<AddIcon />}
              color="primary"
              variant="contained"
              size="small"
            >
              Nova
            </LinkButton>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Table
                autoHeight
                rows={data}
                page={info.current_page - 1}
                pageSize={info.per_page}
                rowCount={info.total}
                columns={columns}
                loading={loading}
                pagination
                paginationMode="server"
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                onFilterClick={filterRef.current?.open}
                canSearch
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default List;
